import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/styles';
import type { DefaultTheme } from '@mui/styles';
import Color from 'color';

interface GridCellProps {
  isOdd: boolean;
}

export const CoverageGridCell = styled(Grid)<DefaultTheme, GridCellProps>(
  ({ theme, isOdd }) => {
    if (isOdd) {
      return {
        textTransform: 'uppercase',
        display: 'flex',
        alignItems: 'center',

        backgroundColor: Color(theme.palette.background.default)
          .lighten(theme.palette.mode === 'dark' ? 0.28 : 0.025)
          .toString(),
      };
    }

    return {
      textTransform: 'uppercase',
      display: 'flex',
      alignItems: 'center',
      backgroundColor:
        theme.palette.mode === 'light'
          ? theme.palette.background.modal
          : Color(theme.palette.background.modal).darken(0.15).toString(),
    };
  }
);

interface DeltaGridCellProps extends GridCellProps {
  isDelta: boolean;
}

export const DeltaGridCell = styled(CoverageGridCell)<
  DefaultTheme,
  DeltaGridCellProps
>(({ theme, isDelta }) => {
  return {
    borderLeft: isDelta
      ? `0.5rem solid ${theme.palette.common.cowbellBlue}`
      : 'none',
  };
});

export const GlobalsHeaderCell = styled(Grid)(({ theme }) => {
  return {
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    fontSize: '1rem',

    backgroundColor: theme.palette.background.default,
  };
});

export const GridHeaderCell = styled(GlobalsHeaderCell)(({ theme }) => {
  return {
    backgroundColor: Color(theme.palette.background.default)
      .lighten(theme.palette.mode === 'dark' ? 0.25 : 0.02)
      .toString(),
  };
});

export const TypographyUppercase = styled(Typography)(() => {
  return {
    textTransform: 'uppercase',
  };
});
